<template>
    <div>
        <span style="line-height: 39px">设置新密码</span>
        <a-form ref="passForm" :model="passForm" :rules="rules" style="margin-top: 32px">
            <a-form-item v-bind="validateInfos.fpwd">
                <a-input-password v-model:value="passForm.fpwd"
                                  size="large" type="password"
                                  placeholder="请输入新的密码">
                    <template #prefix>
                        <LockOutlined class="site-form-item-icon" style="color: rgba(0, 0, 0, 0.25)" />
                    </template>
                </a-input-password>
            </a-form-item>
            <a-form-item v-bind="validateInfos.spwd">
                <a-input-password size="large" type="password"
                                  placeholder="请再次输入密码" v-model:value="passForm.spwd">
                    <template #prefix>
                        <LockOutlined class="site-form-item-icon" style="color: rgba(0, 0, 0, 0.25)" />
                    </template>
                </a-input-password>
            </a-form-item>
            <div class="remenber"></div>
            <a-form-item>
                <a-button type="primary" @click="handlerReset(passForm)"
                          style="width: 100%; height: 40px">下一步</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
import { login } from "@/views/login/api";
import { listenKeyDownFunc } from "@/utils";
import { $post, $get } from "@/utils/request";
import { GloTips, phoneTips } from "@/views/components/api/api";
import { message } from "ant-design-vue";
import Termsindex from "@/views/login/terms.vue";
import UserForm from "@/components/login/user.vue";
import PhoneForm from "@/components/login/phone.vue";
import ForgetPass from "@/components/login/forgetpass.vue";
import { UserOutlined, LockOutlined, MobileOutlined, UpCircleOutlined, LeftCircleOutlined } from "@ant-design/icons-vue";
import { ref, reactive, toRaw } from 'vue';
import { Form } from 'ant-design-vue';
const useForm = Form.useForm;
export default {
    components: { Termsindex, UserForm, PhoneForm, ForgetPass, UserOutlined, LockOutlined, MobileOutlined, UpCircleOutlined, LeftCircleOutlined },
    props: {
        terms: '',
        is_user: '',
        mob: '',
    },
    emits: [
        "handlerReset",
    ],
    data(){
        const password = (rule, value) => {
            if (value === "") {
                return Promise.reject("请输入密码");
            } else {
                return Promise.resolve();
            }
        };
        const password1 = (rule, value) => {
            if (value === "") {
                return Promise.reject("请再次输入密码");
            } else if (value !== this.passForm.fpwd) {
                return Promise.reject("两次密码输入不一致!");
            } else {
                return Promise.resolve();
            }
        };
        const passForm = reactive({
            mob: this.mob,
            fpwd: "",
            spwd: "",
        });
        const rules = reactive({
            fpwd: [{ required: true, validator: password,}],
            spwd: [{ required: true, validator: password1 }],
        });
        const { validate, validateInfos } = useForm(passForm, rules);
        return {
            passForm,
            validate,
            validateInfos,
            rules,
            loading: false,
            button_login: "登录",
            codeShow: true,
            times: 60,
            newtimes: 60,
            passText: "获取验证码",
        };
    },
    methods:{
        handlerReset(form) {
            this.validate().then(() => {
                $post({
                    url: "auth/resetpwd",
                    params: form,
                }).then((res) => {
                    this.$emit('handlerReset',res.data.login_nm)
                }).catch((err) => {
                    message.error(err);
                });
            }).catch(err => {
                this.loading = false;
            });
        },
    },
    mounted() {
        localStorage.setItem("query", JSON.stringify({}));
    },
}
</script>

<style lang="less">
.remenber {
    width: 368px;
    height: 50px;
    padding: 24px 0;
    font-size: 14px;
}
</style>